export { AboutToEnd } from "./AboutToEnd";
export { CustomerDetails } from "./CustomerDetails";
export { OfferInfoBadge } from "./OfferInfoBadge/OfferInfoBadge";
export { PartnerBadge } from "./PartnerBadge";
export { ProblemStatement } from "./ProblemStatement";
